import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import ReactPlayer from 'react-player';
import HtmlParser from 'html-react-parser';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import { DemoFormLongPDFNoBackground} from '../../../components/DemoFormLongPDFNoBackground.jsx';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import MultimedialPanel from '../../../components/MultimedialPanel';

const Home = (props) => {    
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;   


    return (
        <Layout bodyClass="page-remote-work" ontouchstart>
            <SEO title="Setting Remote Work Salaries | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Understand the logistics of offering location-based and value-based salaries while keeping pay as fair and unbiased as possible."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Setting Remote Work Salaries | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Understand the logistics of offering location-based and value-based salaries while keeping pay as fair and unbiased as possible." />
                <meta property="og:image" content={`https://www.charthop.com/img/remote-salaries-preview.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Setting Remote Work Salaries | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Understand the logistics of offering location-based and value-based salaries while keeping pay as fair and unbiased as possible." />
                <meta name="twitter:image" content={`https://www.charthop.com/img/remote-salaries-preview.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>
            
            {/* HEADER */}            
            <section className="hero-dei-reporting">
                <div className="row pb-1 sectionSpacing contentBlock section-big">
                    <div className="headerContent col-md-6 col-sm-12">
                        <h1 className="h1-correct">Download your guide to setting remote work salaries fairly.</h1>
                    </div>
                </div>
                <div className="row pt-1 sectionSpacing contentBlock justify-content-md-start justify-content-center section-big">
                    <DemoFormLongPDFNoBackground pdfUrl={'/resources/remote-work-salaries.pdf'} source={"resources-remote-work-salaries-PDF-contentdownload-header"}/>
                </div>
            </section>

            {/* SET REMOTE */}
            <section className="set-remote sectionSpacing backgroundGradientContainer">
                <div className="contentBlock">
                <h2 className="text-center mt-0 sectionSpacing-Margin">Set remote work salaries fairly with tactical guidance on setting location-based vs. value-based salaries.</h2>
                <h4 className="text-center my-2">In this comprehensive guide you'll learn:</h4>
                <div className="contentBlock">
                    <div className="pgc1-2 pgc1">
                        <div className="pgc2-2 pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>best practices for calculating these pay models</p>
                            </div>
                        </div>
                        <div className="pgc2-2 pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>the logistics of offering location-based and value-based salaries</p>
                            </div>
                        </div>
                        <div className="pgc2-2 pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>strategies to overcome the challenges related to each model</p>
                            </div>
                        </div>
                        <div className="pgc2-2 pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>how to create objective pay criteria to keep pay fair and unbiased</p>
                            </div>
                        </div>
                    </div>                    
                    <p className="text-center mt-2 p-big sectionSpacing-Margin">As companies plan to go remote in the long term, salaries will be more than an accounting issue. How you choose to pay remote employees will have lasting impacts on your company culture.</p>
                </div>
                </div>
            </section>

            {/* TRUSTED */}
            <section className="customer pt-8 pb-5">
                <JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>
            
            {/* CENTRALIZE */}
            <section className="sectionSpacing backgroundGradientContainer" id="see">
				<div className="contentBlock">
                    <MultimedialPanel 
						multimediaPosition="right"
						title="Centralize and collect data"
						link="/product/people-analytics/Integration_reports-2.mp4"
						type="video"
						paddingClass="padding-top-video-1"
						content={
							<React.Fragment>
								<p>Report across any HR system. Integrate data from your HRIS, ATS, Equity, Performance, Identity Management tools and more.</p>
                                <p>Collect any data directly through ChartHop, without an additional survey tool.</p>
							</React.Fragment>
						}
					/>
				</div>
			</section>

		    {/* VISUALIZE */}
			<section className="sectionSpacing" id="see">
				<div className="contentBlock">
                    <MultimedialPanel 
						multimediaPosition="left"
						title="Visualize your data"
						link="/landings/all-in-one.mp4"
						type="video"
						paddingClass="padding-top-video-2"
						content={
							<React.Fragment>
								<p>Go beyond the the spreadsheets and graphs. Bring People data to life like never before.</p>
							</React.Fragment>
						}
					/>
				</div>
			</section>
            
            {/* ANALYZE */}
            <section className="sectionSpacing backgroundGradientContainer" id="see">
				<div className="contentBlock">
                    <MultimedialPanel 
						multimediaPosition="right"
						title="Analyze your trends"
						link="/landings/location-comp.png"
						type="image"
						paddingClass="padding-top-video-3"
						content={
							<React.Fragment>
								<p> Understand your evolution through time-tracked changes. Dissect data across any dimension. </p>
							</React.Fragment>
						}
					/>
				</div>
			</section>

            {/* DRIVE */}
            <section className="drive-comprehensive sectionSpacing">
                <div className="contentBlock">
                    <h2 className="text-center mt-0 sectionSpacing-Margin">Drive a comprehensive DEI Strategy</h2>
                    <h4 className="text-center mt-0 sectionSpacing-Margin">Understand how key factors differ across genders, ethnicities, generations & more. </h4>
					<div className="pgc1">
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Cash Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Equity Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Total Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Levels & Titles</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Performance Reviews</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Promotions & Raises </p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Span of Control</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Engagement & Satisfaction </p>
                            </div>
                        </div>
                    </div>
					<p className="subListTitle mb-0 font-weight-bold text-center">& more</p>
				</div>
            </section>

            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn">
                <h2 className="text-center mt-0 sectionSpacing-Margin">Built to augment your existing tools.</h2>
                <div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack"/>
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                        </div>
                        {/* FIRST 4 */}

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>

                        {/* SECOND 4 */}

                        

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/gusto.png' alt="Gusto" /> 
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-rippling@2x.jpg' alt="Rippling" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" />
                            </div>
                        </div>

                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/sequoia.png' alt="Sequoia" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" />
                            </div>
                        </div>
                        
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/zenefits.png' alt="Zenefits" />
                            </div>
                        </div>  
                        {/* <div> */}
                        <div className="psudeo ps1">
                        </div>

                        <div className="psudeo ps2">
                        </div>

                        <div className="psudeo ps3">
                        </div>

                        <div className="psudeo ps4">
                        </div>
                        {/* </div> */}
                        <h4 className="text-center">& more</h4>
                    </div>
                </div>
            </section>           

            {/* CONTACT FORM */}
            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"resources-remote-work-salaries-demo-bottom"} headertext={HtmlParser("<h2>Let's build a fair and equitable global workforce.<br></br>Together.</h2>")}/>
            </section>

        </Layout>
    );
};


export default Home;


export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;